/* istanbul ignore file */

// The entire purpose of this file is to make window.location testable
// by wrapping it in a function that can be mocked.
// because jest-environment-jsdom wanted purity over testability
// https://github.com/jsdom/jsdom/issues/3492
export function getLocation() {
	return window.location;
}
